import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export default function ConfirmDelete({ count, onCancel, onConfirm }) {
  return (
    <AlertDialog open={count > 0} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="confirm-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Delete {count} {count === 1 ? "enquiry" : "enquiries"}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This permanently removes {count === 1 ? "it" : "them"} and can&rsquo;t be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-delete-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-delete-confirm" onClick={onConfirm}
            className="bg-red-600 hover:bg-red-700 text-white">
            Delete permanently
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
